/* eslint-disable @talend/import-depth */
import merge from 'lodash/merge';

import { locales as adaChatbotLocales } from '@talend/locales-ada-chatbot/locales';
import { namespaces as adaChatbotNamespaces } from '@talend/locales-ada-chatbot/namespaces';
import { locales as designSystemLocales } from '@talend/locales-design-system/locales';
import { namespaces as designSystemNamespaces } from '@talend/locales-design-system/namespaces';
import { locales as datasetLocales } from '@talend/locales-inventory-dataset/locales';
import { namespaces as datasetNamespaces } from '@talend/locales-inventory-dataset/namespaces';
import { locales as ratingLocales } from '@talend/locales-inventory-rating/locales';
import { namespaces as ratingNamespaces } from '@talend/locales-inventory-rating/namespaces';
import { locales as sharingLocales } from '@talend/locales-inventory-sharing/locales';
import { namespaces as sharingNamespaces } from '@talend/locales-inventory-sharing/namespaces';
import { locales as inventoryLocales } from '@talend/locales-inventory/locales';
import { namespaces as inventoryNamespaces } from '@talend/locales-inventory/namespaces';
import { locales as tsdLocales } from '@talend/locales-tsd/locales';
import { namespaces as tsdNamespaces } from '@talend/locales-tsd/namespaces';
import { locales as tuiComponentsLocales } from '@talend/locales-tui-components/locales';
import { namespaces as tuiComponentsNamespaces } from '@talend/locales-tui-components/namespaces';
import { locales as tuiContainersLocales } from '@talend/locales-tui-containers/locales';
import { namespaces as tuiContainersNamespaces } from '@talend/locales-tui-containers/namespaces';
import { locales as tuiDatagridLocales } from '@talend/locales-tui-datagrid/locales';
import { namespaces as tuiDatagridNamespaces } from '@talend/locales-tui-datagrid/namespaces';
import { locales as facetedSearchLocales } from '@talend/locales-tui-faceted-search/locales';
import { namespaces as facetedSearchNamespaces } from '@talend/locales-tui-faceted-search/namespaces';
import { locales as tuiFormsLocales } from '@talend/locales-tui-forms/locales';
import { namespaces as tuiFormsNamespaces } from '@talend/locales-tui-forms/namespaces';
import { locales as enginesLocales } from '@talend/locales-ui-engines/locales';
import { namespaces as enginesNamespaces } from '@talend/locales-ui-engines/namespaces';
import { locales as featureFlippingLocales } from '@talend/locales-ui-feature-flipping/locales';
import { namespaces as featureFlippingNamespaces } from '@talend/locales-ui-feature-flipping/namespaces';
import { locales as notificationCenterLocales } from '@talend/locales-ui-notification-center/locales';
import { namespaces as notificationCenterNamespaces } from '@talend/locales-ui-notification-center/namespaces';
import { locales as ruleRepositoryLocales } from '@talend/locales-ui-rule-repository/locales';
import { namespaces as ruleRepositoryNamespaces } from '@talend/locales-ui-rule-repository/namespaces';

const FR_LOCALE = 'fr';
const JA_LOCALE = 'ja';
const DE_LOCALE = 'de';
export const EN_LOCALE = 'en';
export const LOCALES = [EN_LOCALE, FR_LOCALE, JA_LOCALE, DE_LOCALE];

export const NAMESPACES = [
	...tuiComponentsNamespaces,
	...tuiContainersNamespaces,
	...tuiFormsNamespaces,
	...tuiDatagridNamespaces,
	...tsdNamespaces,
	...enginesNamespaces,
	...datasetNamespaces,
	...ratingNamespaces,
	...sharingNamespaces,
	...facetedSearchNamespaces,
	...notificationCenterNamespaces,
	...inventoryNamespaces,
	...ruleRepositoryNamespaces,
	...featureFlippingNamespaces,
	...designSystemNamespaces,
	...adaChatbotNamespaces,
];

export const localeDefinition = merge(
	tuiComponentsLocales,
	tuiContainersLocales,
	tuiFormsLocales,
	tuiDatagridLocales,
	tsdLocales,
	enginesLocales,
	datasetLocales,
	ratingLocales,
	sharingLocales,
	facetedSearchLocales,
	notificationCenterLocales,
	inventoryLocales,
	ruleRepositoryLocales,
	featureFlippingLocales,
	designSystemLocales,
	adaChatbotLocales,
);
